import React, { useState } from "react";
import { Card, Checkbox, Radio, Alert, Button } from "antd";

const harvestOptions = ["January", "April", "July", "October"];

export default function HarvestBillingSelector() {
    const [harvestMonths, setHarvestMonths] = useState([]);
    const [billingType, setBillingType] = useState(null);

    const nextHarvest = harvestMonths.length > 0 ? harvestMonths[0] : "your next season";
    const billingLabel = {
        monthly: "Monthly billing – pay every month",
        perSeason: "Per Season billing – pay once each growing season",
        postHarvest: `Post-Harvest billing – pay after ${nextHarvest}`
    };

    return (
        <div className="p-6 max-w-4xl mx-auto space-y-6">
            <Card title="1. Select Your Harvest Period">
                <Checkbox.Group
                    options={harvestOptions}
                    value={harvestMonths}
                    onChange={setHarvestMonths}
                />
                <p className="mt-2 text-gray-500 text-sm">
                    Select the months when you usually harvest. We use this to time your payments.
                </p>
            </Card>

            <Card title="2. Choose a Billing Method">
                <Radio.Group
                    onChange={(e) => setBillingType(e.target.value)}
                    value={billingType}
                >
                    <Radio value="monthly">Monthly</Radio>
                    <Radio value="perSeason">Per Season</Radio>
                    <Radio value="postHarvest">Post-Harvest</Radio>
                </Radio.Group>
                <p className="mt-2 text-gray-500 text-sm">
                    Choose the plan that matches your cash flow.
                </p>
            </Card>

            {billingType && (
                <Card title="3. Your Payment Plan Summary">
                    <Alert
                        type="info"
                        message={
                            billingLabel[billingType] || "Select billing type to preview schedule"
                        }
                        description={
                            billingType === "postHarvest"
                                ? `We’ll remind you to pay in the month after your ${nextHarvest} harvest.`
                                : null
                        }
                        showIcon
                    />
                </Card>
            )}

            <div className="text-right">
                <Button type="primary" disabled={!billingType || harvestMonths.length === 0}>
                    Save Preferences
                </Button>
            </div>
        </div>
    );
}
